// Cores/geometria do modo "Colorir por Região" do mapa de Rotas (Iter 108).
export const ZONA_COR = { centro: "#EA580C", norte: "#2563EB", sul: "#16A34A", leste: "#7C3AED", oeste: "#DC2626" };
export const ZONA_LABEL = { centro: "Centro", norte: "Norte", sul: "Sul", leste: "Leste", oeste: "Oeste" };
export const SEM_REGIAO_COR = "#94A3B8";
const EXTRA = ["#0891B2", "#CA8A04", "#DB2777", "#4F46E5", "#65A30D", "#0D9488"];

// regiao_id → cor: zona conhecida usa a cor fixa; demais regiões recebem cores extras em sequência.
export function coresPorRegiao(regioes = []) {
  const m = {};
  let k = 0;
  regioes.forEach((r) => { m[r.id] = r.zona ? ZONA_COR[r.zona] : EXTRA[k++ % EXTRA.length]; });
  return m;
}

// Ponto a `km` de (lat,lng) no rumo `bearing` (graus, 0 = norte) — destino sobre a esfera.
export function destino(lat, lng, bearing, km) {
  const R = 6371, d = km / R, br = (bearing * Math.PI) / 180;
  const p1 = (lat * Math.PI) / 180, l1 = (lng * Math.PI) / 180;
  const p2 = Math.asin(Math.sin(p1) * Math.cos(d) + Math.cos(p1) * Math.sin(d) * Math.cos(br));
  const l2 = l1 + Math.atan2(Math.sin(br) * Math.sin(d) * Math.cos(p1), Math.cos(d) - Math.sin(p1) * Math.sin(p2));
  return [(p2 * 180) / Math.PI, (l2 * 180) / Math.PI];
}

// Divisórias N/S/L/O (diagonais a 45°): da borda do círculo do Centro até `alcanceKm`.
export const linhasZonas = (c, raioKm, alcanceKm = 12) =>
  [45, 135, 225, 315].map((b) => [destino(c.lat, c.lng, b, raioKm), destino(c.lat, c.lng, b, alcanceKm)]);

// Rótulos "Norte/Leste/Sul/Oeste" a `km` do centro em cada direção.
export const rotulosZonas = (c, km = 6) =>
  [["norte", 0], ["leste", 90], ["sul", 180], ["oeste", 270]].map(([zona, b]) => ({ zona, pos: destino(c.lat, c.lng, b, km) }));

export const fmtKm = (v) => `${Number(v).toFixed(1).replace(".", ",")} km`;
